<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="70vw"
      height="80vh"
    >
      <v-card>
        <v-card-actions class="close-button">
          <DsButton
            v-tooltip="closeLabel"
            color="tertiary"
            name="close"
            icon
            @click="dialog = false"
          />
        </v-card-actions>
        <v-card-text class="modal-style">
          <h3>{{ $t("components.ImportHistory.faq1.title") }}</h3>
          <p>{{ $t("components.ImportHistory.faq1.description") }}</p>

          <h3>{{ $t("components.ImportHistory.faq2.title") }}</h3>
          <p>{{ $t("components.ImportHistory.faq2.description") }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <GenericChart
      :request-status="requestStatus"
      :title="title"
      :items="items"
      :map-keys="mapKeys"
      :item-id="itemId"
      :open-dialog="openDialog"
      class="make-a-copy"
      v-bind="$attrs"
      @reload="getData"
    />
    <v-data-table
      :v-if="requestStatus=='success'"
      :headers="headers"
      :items="items"
      :items-per-page="itemsPerPage"
      :loading="inputLoading"
      class="table-truncate"
    >
      <template
        v-slot:item.post_url="{ item }"
        class="log-link"
      >
        <CopyToClipboard
          v-if="urlHandler(item.post_url) === item.post_url"
          :content="item.post_url"
        />
        <v-list-item
          v-else
          v-text="urlHandler(item.post_url)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import GenericChart from '@/components/cards/models/GenericChart';
import sacTypeModel from '@/mixins/sac-type-model';
import channelModel from '@/mixins/channel-model';
import EventBus from '@/utils/event-bus';
import { mapActions, mapGetters } from 'vuex';
import { DsButton } from '@ds/components';
import CopyToClipboard from '@/components/CopyToClipboard';
import { PROJECTION_OPTIONS } from '@/utils/constants.js';

export default {
  name: 'ImportHistory',
  components: {
    GenericChart,
    DsButton,
    CopyToClipboard,
  },
  mixins: [
    sacTypeModel,
    channelModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      items: [],
      dialog: false,
      itemsPerPage: 5,
      requestStatus: 'loading',
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('components.ImportHistory.pid'), value: 'pid' },
        { text: this.$t('components.ImportHistory.username'), value: 'username' },
        { text: this.$t('components.ImportHistory.posted_at'), value: 'posted_at' },
        { text: this.$t('components.ImportHistory.processed_at'), value: 'processed_at' },
        { text: this.$t('components.ImportHistory.post_url'), value: 'post_url' },
      ];
    },
    infoLabel() {
      return this.$t('components.ImportHistory.infoLabel');
    },
    closeLabel() {
      return this.$t('components.ImportHistory.closeLabel');
    },
    mapKeys() {
      return {
        pid: this.$t('components.ImportHistory.pid'),
        username: this.$t('components.ImportHistory.username'),
        posted_at: this.$t('components.ImportHistory.posted_at'),
        processed_at: this.$t('components.ImportHistory.processed_at'),
        post_url: this.$t('components.ImportHistory.post_url'),
      };
    },
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeDashboard',
    ]),
    inputLoading() {
      return this.requestStatus === 'loading';
    },
    getOptions() {
      return this.SAC_TYPE_MAP;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSeStudioEndpointService',
      'pages',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      this.applyFilter(options);
    },
    applyFilter(options) {
      this.requestStatus = 'loading';
      this.items = [];
      this.getSeStudioEndpointService({
        itemId: this.itemId,
        servicePath: 'importHistory',
        serviceParams: {
          projection: PROJECTION_OPTIONS.importHistory,
          sort: true,
        },
      })
        .then((response) => {
          this.items = response.data.map(atribute => {
            const postad_at = new Date (atribute.posted_at).toLocaleString('pt-br');
            const processed_at = new Date (atribute.processed_at).toLocaleString('pt-br');
            atribute.posted_at = postad_at.split(',')[0];
            atribute.processed_at = processed_at;
            return atribute;
          });
          this.requestStatus = 'success';
          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    openDialog() {
      this.dialog = true;
    },
    urlHandler(url) {
      return url === 'undefined' || url === 'null' ? this.$t('components.ImportHistory.unavailableLink') : url;
    },
  },
};
</script>

<style lang="scss" scoped>

.close-button {
  display: flex;
  flex: end;
  justify-content: flex-end;
}

::v-deep {
  .table-truncate {
    td {
      max-width: 10vw;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .modal-style {
    * {
      color: var(--ds-color-snow) !important;
    }

    h3 {
      font-weight: var(--ds-font-weight-bold);
    }
  }

  .log-link {
    cursor: pointer;
  }
}
</style>
